import Cookie from 'js-cookie'
import _ from 'lodash'
import axios, { AxiosRequestConfig } from 'axios'
import { Notification } from 'element-ui'
import { FORBIDDEN, UNAUTHORIZED } from 'http-status-codes'

import store from '@/store'
import {
    applyTenantSessionHeader,
    createTenantSessionRecoveryError,
    recoverTenantSession
} from '@/utils/login-session'
const debounceNotification = _.debounce(errNoticeHandle, 300)

function errNoticeHandle(errorMessage: string) {
    return Notification.error(errorMessage)
}

export default {
    setupInterceptors: () => {
        axios.interceptors.request.use((config: AxiosRequestConfig) => {
            const authInfo = store.state.auth.authInfo
            config.headers = {
                ...config.headers,
                tenantId: authInfo && authInfo.tenantId,
                userId: authInfo && authInfo.userId,
                'Accept-Language': Cookie.get('language') || 'zh'
            }
            config.headers = applyTenantSessionHeader(config.headers)
            return config
        })

        axios.interceptors.response.use(
            // @ts-ignore
            response => {
                // console.log(response)
                if (response.data instanceof Blob) {
                    return response.data
                }

                const { code, msg, data } = response.data
                // TODO 支付老系统： 000000 表示有成功的返回数据
                if (code === '0' || code === '000000') {
                    return response
                } else if (code === '3002' || code === '3001') {
                    recoverTenantSession(data)
                    return Promise.reject(createTenantSessionRecoveryError())
                } else if (code === '3003') {
                    // 无此操作权限
                    Notification.error(msg)
                }

                return Promise.reject(new Error(msg))
            },
            error => {
                const resp = error.response
                if (!resp) {
                    return Promise.reject(error)
                }
                if (resp.status === UNAUTHORIZED) {
                    // store.dispatch(userLogout)
                    // history.push('/admin/login')
                }

                if (resp.status === FORBIDDEN) {
                    // history.push('/admin/login')
                }

                if (resp) {
                    if (resp.data && resp.data.msg) {
                        debounceNotification(resp.data.msg)
                        return Promise.reject(resp.data)
                    } else if (error instanceof Error) {
                        debounceNotification(error.message)
                        return Promise.reject(error)
                    }
                }
            }
        )
    }
}
